import { render, staticRenderFns } from "./SelectTipoHIstorico.vue?vue&type=template&id=0f27ec84&scoped=true"
import script from "./SelectTipoHIstorico.vue?vue&type=script&lang=js"
export * from "./SelectTipoHIstorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27ec84",
  null
  
)

export default component.exports